var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"search-background"},[_c('el-input',{staticClass:"search",attrs:{"placeholder":"请输入检索内容","suffix-icon":"el-icon-search"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }